export default "__VITE_ASSET__DYvS$Zb___"